import $ from 'jquery';

$(document).ready(function () {
    $(".filterBtn").click(function(){
        $("*").removeClass("activeBtn");
        $("*").removeClass("fadeInRight");

        $(this).addClass("activeBtn")


        var filter = $(this).attr('data-filter');
        if (filter === 'all') {
            $('#projectsContaner').children().addClass("fadeInRight").show();
        } else {
            $('#projectsContaner').children(':not(.' + filter + ')').hide();
            $('#projectsContaner').children('.' + filter).addClass("fadeInLeft").show();;
        }
    })
})